// extracted by mini-css-extract-plugin
module.exports = {"questionTitle":"quizGlobalStyle_questionTitle__3hM42","quizButtonText":"quizGlobalStyle_quizButtonText__3O8Fl","questionTitleInfo":"quizGlobalStyle_questionTitleInfo__1PbDc"};